import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconYoutubeStyle0 = gravityIconIndividualCss;

const GravityIconYoutube = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'f5b9217835422baf77b148bc29d2aa389a8228d4', color: this.color, size: this.size }, h("svg", { key: '936d6ba24bd363b4fce055155fae4b28b17a1675', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '3f86be7da27262120dfb191af9e09a3188c86158', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.14 6.9a2.14 2.14 0 0 0-1.5-1.51A50.15 50.15 0 0 0 11 5a50.151 50.151 0 0 0-6.64.36 2.14 2.14 0 0 0-1.5 1.54 22.72 22.72 0 0 0-.35 4.1 22.63 22.63 0 0 0 .35 4.11 2.12 2.12 0 0 0 1.5 1.51c2.202.273 4.42.4 6.64.38a50.169 50.169 0 0 0 6.64-.36 2.12 2.12 0 0 0 1.5-1.51c.243-1.363.36-2.746.35-4.13a22.723 22.723 0 0 0-.35-4.1Zm-9.88 6.64v-5L13.7 11l-4.44 2.54Z", fill: "currentColor" }))));
    }
};
GravityIconYoutube.style = GravityIconYoutubeStyle0;

export { GravityIconYoutube as gravity_icon_youtube };

//# sourceMappingURL=gravity-icon-youtube.entry.js.map